module.exports = __webpack_public_path__ + "static/img/40013 (2).c7eb26b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40013 (2).webp
// module id = bjxJ
// module chunks = 14